import { useId } from 'react';

import { MOTIVO_MAXIMO, MOTIVO_MINIMO } from '@/lib/motivo';

import { contadorDoMotivo } from './contador-do-motivo';

/**
 * O CAMPO DO MOTIVO (R06, p.69): estornar, corrigir e desativar pedem um
 * motivo de pelo menos 10 caracteres, que vai para a trilha.
 *
 * Abaixo do campo, a ajuda "Mínimo de 10 caracteres. Fica na trilha." e, à
 * direita, o contador "42 de 10": quantos já foram escritos contra o piso. Os
 * dois ficam verdes quando o piso é cumprido — o botão que confirma só liga aí,
 * e quem chama confere com `motivoValido` (`@/lib/motivo`).
 */
export function CampoDoMotivo({
  valor,
  aoMudar,
  rotulo = 'Motivo',
  exemplo,
  minimo = MOTIVO_MINIMO,
  maximo = MOTIVO_MAXIMO,
}: {
  readonly valor: string;
  readonly aoMudar: (valor: string) => void;
  readonly rotulo?: string;
  /** O exemplo, no lugar vazio: "Lançado na máquina errada, era a ESC-009". */
  readonly exemplo?: string;
  readonly minimo?: number;
  readonly maximo?: number;
}) {
  const id = useId();
  const contador = contadorDoMotivo(valor, minimo);
  const tom = contador.cumpre ? 'text-sucesso-texto' : 'text-tinta-apagada';
  return (
    <div className="flex min-w-0 flex-col gap-2">
      <label htmlFor={id} className="txt-rotulo-campo">
        {rotulo}
      </label>
      <textarea
        id={id}
        className="controle h-auto min-h-[88px] w-full resize-y py-2"
        rows={3}
        maxLength={maximo}
        value={valor}
        placeholder={exemplo}
        aria-describedby={`${id}-ajuda ${id}-contador`}
        onChange={(e) => {
          aoMudar(e.target.value);
        }}
      />
      <div className="flex items-start justify-between gap-3">
        <span id={`${id}-ajuda`} className={`txt-ajuda ${tom}`}>
          {`Mínimo de ${String(minimo)} caracteres. Fica na trilha.`}
        </span>
        <span id={`${id}-contador`} aria-live="polite" className={`txt-ajuda shrink-0 tabular-nums ${tom}`}>
          {contador.texto}
        </span>
      </div>
    </div>
  );
}
